import { CaseBoardListFilters } from '@/store/cases-board.store';
import { QUICK_FILTERS } from '@/constants/filters';

export const getQuickFiltersItems = (filters: Partial<CaseBoardListFilters>) => {
  const selectedItems = [];
  if (filters.assignedMe) selectedItems.push(QUICK_FILTERS.assignedMe);
  if (filters.favorites) selectedItems.push(QUICK_FILTERS.favorites);
  if (filters.recent) selectedItems.push(QUICK_FILTERS.recent);
  if (filters.duplicates) selectedItems.push(QUICK_FILTERS.duplicates);
  return selectedItems;
};
